import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    if (token) {
      setIsLoggedIn(true);
      // Здесь можно загрузить данные пользователя
      setUser({ role: localStorage.getItem('user_role') || 'user' });
    }
  }, [token]);

  const handleLogin = (loginData) => {
    setIsLoggedIn(true);
    setUser(loginData.user);
    setToken(loginData.token);
    localStorage.setItem('token', loginData.token);
    localStorage.setItem('user_role', loginData.user.role);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUser(null);
    setToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user_role');
  };

  return (
    <div className="App">
      {!isLoggedIn ? (
        <Login onLogin={handleLogin} />
      ) : (
        <Dashboard user={user} token={token} onLogout={handleLogout} />
      )}
    </div>
  );
}

export default App;
